// Recovered compiled webpack factory 99256. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { n: () => n });
  let n = "data-" + (0, i(32246).I)("framerAppearId");
}
